import {useContext} from 'react'
import {ChromelessContext} from './context'
import {isChromelessPath} from './is-chromeless-path'

// Are we in a chromeless context or path?
export const useChromeless = (): boolean => {
  const inChromelessContext = useContext(ChromelessContext)
  return isChromelessPath() || inChromelessContext
}
